import { useRoleController } from "@/components/useRoleController";
import {
  CATALOG_CODE_PRIVILEGE,
  CatalogCodeType,
  MASTER_DATA_PRIVILEGE,
} from "../catalog-constant";

/**
 * Row actions (Edit / Archive / Unarchive) of a catalog tab unlock on the
 * granular "Master Data > ..." privilege of that code type, or on the parent
 * "Master Data" module when the role is granted at that level.
 */
export const useCatalogCodeAccess = (type: CatalogCodeType): boolean => {
  const { hasUpdate: hasMasterData } = useRoleController(MASTER_DATA_PRIVILEGE);
  const { hasUpdate: hasCodeUpdate } = useRoleController(
    CATALOG_CODE_PRIVILEGE[type]
  );

  return hasMasterData || hasCodeUpdate;
};
